import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";
import history from "../../auth/history";
import Footer from './../FooterComponent/FooterComponet';
import { v4 as uuidv4 } from 'uuid';
import { store } from "../../redux/store";
import { setAddBenefisciaryRequest, setAddBenefisciaryRequestUrl, setBeneCustomerId, setBeneSubDetails, setIfscCode, setSelectedBankId, setSelectedBankName } from "../../redux/misc-data/misc-data.action";
import { setSendersListDetails, setOtpResponse } from './../../redux/misc-data/misc-data.action';
import Select from 'react-select'
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
const httpClient = axios.create();
class AddBeneficiary extends React.Component{
    constructor(props){
        super(props);
        this.state={

			benefisciaryName:'',
			benefisciaryMobile:'',
			phoneNo: this.props.phone,
			senderNameValue:'',
			selectedAccountNumber:'',
			confirmedAccountNumber:'',
		
			selectedBankName:'',
			ifscCode:'',
			selectedIfsc:'',
			selectedBankId:'',
			bankSelectMessage:'',
			bankDetails:[],

			errorMessage:'',

			checked:true

		}
		this.handleCheck=this.handleCheck.bind(this)
    }
	addbenefisciaryName=(event)=>{
		this.setState({
			benefisciaryName:event.target.value
		})
	}

	addbenefisciaryMobileNo=(event)=>{
		this.setState({
			benefisciaryMobile:event.target.value
		})
	}

	handleCheck(){
		this.setState({
			checked:!this.state.checked
		})
	}


	bankChange=(selected)=>{

		if(selected.value=='Select'){
			
			this.setState({
				bankSelectMessage:'Please select a bank'
			})
		}else{
			console.log(selected.value);
		this.setState({
			selectedBankName:selected.value,
		})

		


		console.log(JSON.stringify(this.props.bankDetails));
		this.props.bankDetails.map(banks=>{
			if(banks.name==selected.value){

			
				if(banks.masterIfsc!=null && banks.masterIfsc!=''){
					this.setState({
						ifscCode:banks.masterIfsc
					})
				}
				this.setState({
				
					selectedBankId:banks.id
				})
				store.dispatch(setIfscCode(banks.masterIfsc!=null?
				banks.masterIfsc.toUpperCase():''));
				
				store.dispatch(setSelectedBankId(banks.id));
				
			}
		})

	
		
		}
	}


	ifscChange=(event)=>{
		// store.dispatch(setIfscCode(''));
	
		console.log(event.target.value);
		this.setState({
			selectedIfsc:event.target.value.toUpperCase(),
		})

		// store.dispatch(setIfscCode(event.target.value.toUpperCase()));
	}
	
	
	selectAccountNumber=(event)=>{
		this.setState({
			selectedAccountNumber:event.target.value
		})
	}


	confirmAccountNumber=(event)=>{
		this.setState({
			confirmedAccountNumber:event.target.value
		})
	}

    componentDidMount(){
		store.dispatch(setAddBenefisciaryRequest(''));
		store.dispatch(setBeneCustomerId(''));

		
	}
	componentWillUnmount(){
    }


    dashBoard=()=>{
      history.push('/dmt');
      history.go();
    }

    addBenefisciaryDetails=(event)=>{
		
		event.preventDefault();

		console.log('values...'+this.props.selectedBankName+ " "+ JSON.stringify(this.props.selectSender));

		const headers = { 'Authorization': 'Bearer '+this.props.token,
		'client-id':this.props.agentInfo.id,
		'role' :this.props.clieb}


		var nameResult=this.validateName();
		var accountConfirm=(this.state.selectedAccountNumber==this.state.confirmedAccountNumber); 
		
		if(accountConfirm==true 
		&&nameResult==true){

            const url='/api/v1/dmt/beneficiary/add';

			const addBenefisciaryRequestHeader={
				msgType:"ADD_BENEFICIARY",
				service:"DMT",
				src:"add-beneficiary",
				dst:"review-add-beneficiary",
				channel:"WHITELABEL",
				requesterId: this.props.clientRequesterId,
				requestId:uuidv4(),
				traceId:uuidv4(),
			}



			var selectedBankName='';

			selectedBankName=this.state.selectedBankName==''?this.props.selectedBankName:this.state.selectedBankName;
		
			const bankAccountDetails={
				bank:this.state.selectedBankName==''?this.props.selectedBankName:this.state.selectedBankName,
				branch:this.props.branchAddress,
				accNum:this.state.selectedAccountNumber,
				ifsc:this.state.selectedIfsc==''?this.props.ifscCode.toUpperCase():this.state.selectedIfsc.toUpperCase()
			}

			console.log('bankAccountDetails'+JSON.stringify(bankAccountDetails));


			var sendermobile=''

			
			sendermobile=this.props.selectSender.customer.mobile;
			var customerId='';


			customerId=this.props.selectSender.customer.id;
			

		
			const beneficiary={
				name:this.state.benefisciaryName,
				mobile:this.state.benefisciaryMobile,
				email:"",
				account:bankAccountDetails,
				verified:false,
				addedBy:sendermobile
			}

			const otp={
				mobile:this.state.senderMobileNo,
				type:"ADD_DMT_BENEFICIARY"
			}
	
			const addBenefisciaryRequest={
				header:addBenefisciaryRequestHeader,
				beneficiary:beneficiary,
				deviceInfo:this.props.deviceInfo,
				otp:otp,
				customerId:customerId
			}

			console.log('addBenefisciaryRequest..'+JSON.stringify(addBenefisciaryRequest));

			const otpUrl="/api/v1/otp/generate";
			const generateOtprRequestHeader={
				msgType:"GENERATE_OTP",
				service:"DMT",
				src:"add-benefisciary",
				dst:"review-benefisciary",
				channel:"WHITELABEL",
				requesterId: this.props.clientRequesterId,
				requestId:uuidv4(),
				traceId:uuidv4(),
			}
			
			const generateOtpRequest={
				header:generateOtprRequestHeader,
				otpDetails:otp
			}

			httpClient.post(otpUrl,generateOtpRequest,{headers}
				).then((response) => {
					console.log('otp generate response'+JSON.stringify(response.data));
						if(response.data.response.msg=='SUCCESS'){
								store.dispatch(setAddBenefisciaryRequest(addBenefisciaryRequest));
								store.dispatch(setOtpResponse(response.data));
								store.dispatch(setAddBenefisciaryRequestUrl(url));
                              

								var accno=addBenefisciaryRequest.beneficiary.account.accNum;
								var accnoMiddle='';
									for (let i = 0; i < accno.length; i++) {
										accnoMiddle=accnoMiddle+'x';
								} 
							var accountNo=	accno.substring(0,2)+accnoMiddle.substring(2,accno.length-2)+
							accno.substring(accno.length-1,accno.length);

							var idvalue=this.props.selectSender.customer.kyc.id;
							var idmiddle='';
								for (let i = 0; i < idvalue.length; i++) {
									idmiddle=idmiddle+'x';
							} 
							var govtIdvalue=	idvalue.substring(0,2)+idmiddle.substring(2,idvalue.length-2)+
							idvalue.substring(idvalue.length-1,idvalue.length);
							var benefisciarySubDetails={
								benefisciaryName:addBenefisciaryRequest.beneficiary.name,
								bankName:selectedBankName,
								accountNumber:addBenefisciaryRequest.beneficiary.account.accNum,
								benefisciaryMobile:addBenefisciaryRequest.beneficiary.mobile,
								ifscCode:this.state.selectedIfsc==''?this.props.ifscCode.toUpperCase():this.state.selectedIfsc.toUpperCase(),
								customerName:this.props.selectSender.customer.name,
								govtIdType:this.props.selectSender.customer.kyc.type.replace("-"," "),
								govtIdValue:this.props.selectSender.customer.kyc.id,
								senderMobile:this.props.selectSender.customer.mobile
					
							 }


								 console.log('benefisciarySubDetails...'+JSON.stringify(benefisciarySubDetails));
						
								 store.dispatch(setBeneSubDetails(benefisciarySubDetails));
	
								history.push('/review-add-beneficiary');
								history.go();
								}else{
									this.errorMessageCall(response.data.response.displayMsg);
								}
						}).catch(error => {
								this.errorMessageCall(error.message);
								
			});
	
		}
		else{
			var accountConfirmMessage="";
			if(accountConfirm==false){
				accountConfirmMessage="Account number mismatched";
				this.errorMessageCall(accountConfirmMessage);
			}
		}
	}
	

	
	searchIfsc=()=>{

	
        history.push('/search-ifsc');
        history.go();
      }
	
	

	errorMessageCall=(error)=>{
		this.setState({
			errorMessage:error
		})
	}





	  validateName(){
		// var regName = /^[a-zA-Z]+ [a-zA-Z]+$/;
		var regName =/^\s*(\S+)\s+(?:\S+\s+)?(\S+)\s*$/
		var name = this.state.benefisciaryName;
		if(!regName.test(name)){
			alert('Please enter your full name');
			return false;
		}else{
			
			return true;
		}
	}


    render(){


	var searchableBankList=[];
	
      

	this.props.bankDetails.map(bank=>
		{
			var stateVal={
				value:'',
				label:''
			}
			stateVal.value=bank.name;
			stateVal.label=bank.name;
			searchableBankList.push(stateVal);
		})
	
    return(
        
    <div>
		<HeaderCommon/>
		<Menu/>
    <div class="main">
       

        <div class="right-side">
		<div class="container-fluid">

		

        <div class="row">				
				<div class="col-12">
					<div class="card-b">
						<div id="recenttxn">
							<div class="head">								
								<h3>Add Beneficiary</h3>
								<div class="headbtn">
									<button class="dbbtn" onClick={this.dashBoard} type="button">Back</button>
								</div>						
							</div>
							

							<form onSubmit={this.addBenefisciaryDetails}>
							<div class="dashform">
								<div class="row">


								{this.state.invalidBankSelectionMessage}
							
								

							
									{this.props.selectedBankName!='' &&
									<div class="col-12 col-sm-6 col-xl-5">
									<label for="bank">Bank Name</label>
											<div class="form-floating">

											<div class="form-floating">
											<Select options={searchableBankList} class="form-control"
											defaultValue={{ label: this.props.selectedBankName, value: this.props.selectedBankName}}
											onChange={this.bankChange} required
											/>
											
										</div>
								
										</div>
									</div>
									}

									
					
									{this.props.ifscCode!=''  &&
									<div class="col-12 col-sm-6 col-xl-5">
									<div class="form-floating">
									    
										<input type="text" class="form-control" id="code" 
										value={this.props.ifscCode} readOnly>

										</input>
									
										<label for="code">IFSC Code</label>
									
									</div>
									</div>
									}

									{this.props.ifscCode==''  &&
									<div class="col-12 col-sm-6 col-xl-5">
									<div class="form-floating">
									
										<input type="text" class="form-control" id="code"
										onInput={(e) => e.target.value = e.target.value.slice(0, 11)}
										placeholder="IFSC Code" required 
										onChange={this.ifscChange}>
											

										</input>
										<button class="lbbtn otpbtn" type="button" onClick={this.searchIfsc}
										>Search</button>
									
										<label for="code">IFSC Code</label>
									
									</div>
									</div>
									}

									<div class="col-12 col-sm-6 col-xl-5">
									<div class="form-floating">
											<input type="number" class="form-control" id="mobile" 
											placeholder="Mobile"
											onInput={(e) => e.target.value = e.target.value.slice(0, 16)}
											onChange={this.selectAccountNumber}
											required/>
											<label for="mobile">Account Number</label>
										</div>
									</div>
									
									<div class="col-12 col-sm-6 col-xl-5">
									<div class="form-floating">
											<input type="number" class="form-control" id="txnid" placeholder="ID Number"
											onInput={(e) => e.target.value = e.target.value.slice(0, 16)}
											onChange={this.confirmAccountNumber}
											required/>
											<label for="txnid">Confirm Account Number</label>
										</div>
									</div>									
									
									<div class="col-12 col-sm-6 col-xl-5">
									<div class="form-floating">
											<input type="text" class="form-control" id="nmae" 
											placeholder="Sender Name"
											onChange={this.addbenefisciaryName}
											required/>
											<label for="nmae">Beneficiary Name</label>
										</div>
									</div>


									<div class="col-12 col-sm-6 col-xl-5">
										<div class="form-floating">
										<input type="number" class="form-control" id="nmae" 
											placeholder="Bene Mobile No"
											onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
											onChange={this.addbenefisciaryMobileNo}
											/>

											<label for="bmobi">Beneficiary Mobile No.</label>
										</div>
									</div>
									

									<div class="col-12">
										<div class="form-check">
											<input class="form-check-input" type="checkbox" value="" 
											id="flexCheckChecked" checked
											defaultChecked={this.state.checked}
											onChange={this.handleCheck}
											/>
											<label class="form-check-label" for="flexCheckChecked">
											Sender wants to validate beneficiary details from bank and agrees to pay Rs. 1 for verification.
											</label>
										</div>	
									</div>
									
									<div class="col-12">
										<button type="submit" class="btn btn-primary" 
										// onClick={this.benefisciary}
										>
										Continue</button>
									</div>
									
								</div>
							</div>
							</form>
							{this.state.errorMessage!='' &&
							<div class='valid-error'>{this.state.errorMessage}
							</div>}
						</div>
					</div>
				</div>	
			</div>
		</div>	
	</div>
</div>
<Footer/>
</div>
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage},
	 miscReduce:{phone,customerId,deviceInfo,addsenderRequest,bankDetails,selectedBankName,
		selecetdBankId,
		ifscCode,token,clientRequesterId,agentInfo,selectSender,beneSubDetails,branchAddress,selecetedBankname,
	}}
	) => ({
		errorMessage,loginErrorMessage,phone,customerId,deviceInfo,addsenderRequest,bankDetails,
		selectedBankName,selecetdBankId,
		ifscCode,token,clientRequesterId,agentInfo,selectSender,beneSubDetails,branchAddress,selecetedBankname
});

export default connect(mapStateToProps, null)(AddBeneficiary);
